import { render, staticRenderFns } from "./CarouselWrap.vue?vue&type=template&id=15aee25e&"
import script from "./CarouselWrap.vue?vue&type=script&lang=js&"
export * from "./CarouselWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports